import React from "react";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { checkEmail } from "../images";
import Text from "../text/Text";
import {
  checkEmailMsg,
  forgotPasswordConfirmationHeader,
  forgotPasswordConfirmationSubHeader,
  resend,
  resendForgotPwdLinkMsg,
} from "../messages";
import { CustomLink } from "../link/Link";
import {
  callAPIInterface,
  isTMA,
  sourceTelegramApp,
  sourceWebWallet,
} from "../constants";
import { showToast } from "../../redux/actions";

const ForgotPasswordConfirmation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const email = location?.state?.email;
  const handleForgotPassword = async () => {
    try {
      await callAPIInterface(
        "POST",
        "/forgot-password",
        JSON.stringify({
          email: email,
          source: isTMA() ? sourceTelegramApp : sourceWebWallet,
        })
      );
      dispatch(
        showToast({
          isToastOpen: true,
          toastMessage: resendForgotPwdLinkMsg,
          toastVariant: "success",
        })
      );
    } catch (error) {}
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
    >
      <img src={checkEmail} height={193} width={170} />
      <Text
        className="default-text mt-24"
        size={22}
        font="bold"
        sx={{ mt: 40 }}
      >
        {forgotPasswordConfirmationHeader}
      </Text>
      <Text className="grey-text mt-8" size={14}>
        {forgotPasswordConfirmationSubHeader}
      </Text>
      <Text className="default-text mt-24" size={14}>
        {checkEmailMsg}{" "}
        <CustomLink bold onClick={handleForgotPassword} size="small">
          {resend}
        </CustomLink>
      </Text>
    </Box>
  );
};

export default ForgotPasswordConfirmation;
